(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sis-gift-recipient"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sis-gift-recipient')) {
    customElements.define(
      'sis-gift-recipient',
      class extends HTMLElement {
        connectedCallback() {
          this.check = this.querySelector('.sis-gift__check');
          this.fields = this.querySelector('.sis-gift__fields');
          if (!this.check || !this.fields) return;
          this.form = this.closest('.shopify-section')?.querySelector('form[data-type="add-to-cart-form"]');
          if (this.form) {
            // getAttribute, not form.id: the form has an input named "id", which shadows the property
            let formId = this.form.getAttribute('id');
            if (!formId) {
              formId = 'SisGiftForm-' + Math.random().toString(36).slice(2);
              this.form.setAttribute('id', formId);
            }
            this.fields.querySelectorAll('[name]').forEach((input) => input.setAttribute('form', formId));
          }
          this.onChange = () => this.toggle();
          this.check.addEventListener('change', this.onChange);
          this.onSubmit = (event) => this.guard(event);
          window.addEventListener('submit', this.onSubmit, true);
          this.toggle();
        }

        disconnectedCallback() {
          this.check?.removeEventListener('change', this.onChange);
          window.removeEventListener('submit', this.onSubmit, true);
        }

        toggle() {
          const on = this.check.checked;
          this.fields.hidden = !on;
          this.classList.toggle('is-on', on);
          this.fields.querySelectorAll('[name]').forEach((input) => {
            input.disabled = !on;
          });
          const offset = this.fields.querySelector('[name="properties[__shopify_offset]"]');
          if (offset) offset.value = String(new Date().getTimezoneOffset());
        }

        // Horizon's form skips the browser's checks (novalidate) and handles submit on document
        // (capture), so check the email on window, which runs first
        guard(event) {
          if (event.target !== this.form || !this.check.checked) return;
          const email = this.fields.querySelector('[name="properties[Recipient email]"]');
          const date = this.fields.querySelector('[name="properties[Send on]"]');
          email.setCustomValidity('');
          if (!email.validity.valid) email.setCustomValidity(this.dataset.emailError || '');
          for (const input of [email, date]) {
            if (input && !input.checkValidity()) {
              event.preventDefault();
              event.stopImmediatePropagation();
              input.reportValidity();
              return;
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
